import protoRoot from "../proto-root";
import createMessage from "./createMessage";

const name = "stopCommandMessage";

function create() {
  const StopCommandMessage = protoRoot.lookupType(`comm.StopCommandMessage`);

  return createMessage({ [name]: StopCommandMessage.create() });
}

export default {
  create,
  name
};
